import { render, staticRenderFns } from "./r-boat-config-page.vue?vue&type=template&id=51f8441f"
import script from "./r-boat-config-page.vue?vue&type=script&lang=js"
export * from "./r-boat-config-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f8441f')) {
      api.createRecord('51f8441f', component.options)
    } else {
      api.reload('51f8441f', component.options)
    }
    module.hot.accept("./r-boat-config-page.vue?vue&type=template&id=51f8441f", function () {
      api.rerender('51f8441f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-config-page.vue"
export default component.exports